import React from 'react';
import classNames from 'classnames'
import { Divider, Spacer } from '@cleartrip/bento';
import {RightChevron} from '@cleartrip/bento-icons';
import { langTranslate } from "helper/arabic";


function SideNav({active, isRTL = false}) {

  const chevronDirection = {transform: 'rotate(180deg)'};

	return (
		<div className='w-80p w-100p--xs p-sticky t-0'>
			<Spacer className='pt-15 pt-3--xs' />
			<a href='/about' target='_blank' className='flex flex-middle flex-between td-none hover:td-underline'>
				<p className={classNames('lh-copy fs-3 c-secondary-500 fw-500', {'c-tertiary-500': active === 'about'})} >{langTranslate("About")}</p>
				<RightChevron className='d-none d-block--xs' height={16} width={16} style={isRTL ? chevronDirection : {}}/>
			</a>
			{/* <Divider className='pt-2 mb-2' />
			<a href='/press' target='_blank' className='flex flex-middle flex-between td-none hover:td-underline'>
				<p className={classNames('lh-copy fs-3 c-secondary-500 fw-500', {'c-tertiary-500': active === 'pressInfo'})}>{langTranslate("Press info")}</p>
				<RightChevron className='d-none d-block--xs' height={16} width={16} style={isRTL ? chevronDirection : {}}/>
			</a> */}
			{/* <Divider className='pt-2 mb-2' />
			<a href='/animal-welfare' target='_blank' className='flex flex-middle flex-between td-none hover:td-underline'>
				<p className={classNames('lh-copy fs-3 c-secondary-500 fw-500', {'c-tertiary-500': active === 'sustainability'})}>{langTranslate("Sustainability")}</p>
				<RightChevron className='d-none d-block--xs' height={16} width={16} style={isRTL ? chevronDirection : {}}/>
			</a> */}
			<Divider className='lh-copy pt-2 mb-2' />
			<a href='/contact' target='_blank' className='flex flex-middle flex-between td-none hover:td-underline'>
				<p className={classNames('lh-copy fs-3 c-secondary-500 fw-500', {'c-tertiary-500': active === 'contact'})}>{langTranslate("Contact")}</p>
				<RightChevron className='d-none d-block--xs' height={16} width={16} style={isRTL ? chevronDirection : {}}/>
			</a>
			<Divider className='lh-copy pt-2 mb-2' />
		</div>
	);
}

export default SideNav;
